import { RefreshControl as RNRefreshControl, RefreshControlProps } from 'react-native'
import { color } from '@mythical/ui'

export function RefreshControl(props: RefreshControlProps) {
  return (
    <RNRefreshControl
      {...props}
      tintColor={color.fgPrimary} // iOS
      colors={[color.bgPrimary]} // Android
    />
  )
}
